import { render, staticRenderFns } from "./ConsigneeForm.vue?vue&type=template&id=63a9be36&scoped=true"
import script from "./ConsigneeForm.vue?vue&type=script&lang=js"
export * from "./ConsigneeForm.vue?vue&type=script&lang=js"
import style0 from "./ConsigneeForm.vue?vue&type=style&index=0&id=63a9be36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a9be36",
  null
  
)

export default component.exports